import c from "../../utils/constants";

class VouchesController {
  constructor(VouchesService, FilterService, NotificationService, AuthService, $scope) {
    "ngInject"

    this.vouchesService = VouchesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  $onInit() {
    this.vouchStatusOptions = {
      dataSource: [
        { value: 1, text: "Follow-up" },
        { value: 2, text: "Complete" },
        { value: 3, text: "Incomplete" },
        // { value: 4, text: "Expired" },
      ],
      dataTextField: "text",
      dataValueField: "value",
    }
  }

  getGridOptions() {

    return {
      dataSource: this.vouchesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
      sortable: true,
      pageable: true,
      resizable: true,
      save: this.saveChanges.bind(this),
      height: "90vh",
      // toolbar: [{ name: "create", text: "Create Reference" }],
      noRecords: {
        template: "No References."
      },
      columns: [
        {
          field: "helperName", title: "Helper Name", filterable: false, attributes: {"class": "col-name"}, width: "4rem",
          template: (dataItem) => `<a class="cell" href="/users/${dataItem.jugglerId}"><span>${dataItem.helperName}</span></a>`,
        },
        { field: "fullName", title: "Voucher", filterable: false, width: "4rem" },
        { field: "interestedInAuPairJobs", title: "Is Au Pair?", filterable: false, width: "2rem", template: (dataItem) => `${dataItem.interestedInAuPairJobs ? 'Yes' : 'No'}` },
        { field: "status", title: "Status", filterable: false, width: "4rem", template: (dataItem) => `${this._getVouchStatus(dataItem.status)}` },
        { field: "referenceType", title: "Type", filterable: false, width: "4rem", template: (dataItem) => `${this._getVouchReferenceType(dataItem.referenceType, dataItem.otherReferenceType)}` },
        { field: "email", title: "Email", filterable: false, width: "6rem" },
        { field: "phoneNumber", title: "Phone Number", filterable: false, width: "6rem" },
        { field: "submissionDate", title: "Submission Date", filterable: false, width: "4rem", template: `#= submissionDate ? kendo.toString(new Date(submissionDate), 'dd-MM-yyyy') : '-' #` },
        { title: "Update", command: [{ name: "edit", text: "Update" }], width: "4rem" },
      ],
      editable: {
        mode: "popup",
        window: { title: "Vouch" },
        template: kendo.template($("#popup-editor").html())
      }
    }
  }

  saveChanges(e) {
    const status = e.model;

    if ((status.status == 2) && (!status.whatWouldYouLikeToSay || !status.jugglerId)) {
      this.notificationService.error("Check missing fields and try again.");
      e.preventDefault();
    }
  }

  _getVouchStatus(status) {
    switch(status) {
      case c.vouchStatus.PENDING:
        return "Follow-up";
      case c.vouchStatus.APPROVED:
        return "Complete";
      case c.vouchStatus.CANCELLED:
        return "Incomplete";
        case c.vouchStatus.EXPIRED:
          return "Expired";
      case c.vouchStatus.NONE:
        return "-";
    }
  }

  _getVouchReferenceType(status, otherReferenceType) {
    switch(status) {
      case c.vouchReferenceType.FAMILY:
        return "Family";
      case c.vouchReferenceType.CHILDCAREEMPLOYMENT:
        return "Childcare Employment";
      case c.vouchReferenceType.NONCHILDCAREEMPLOYMENT:
        return "Non-childcare Employment";
      case c.vouchReferenceType.OTHER:
        return "Other (" + otherReferenceType + ")";
      case c.vouchReferenceType.JUGGLESTREET:
        return "Juggle Street";
        case c.vouchReferenceType.UNSPECIFIED:
          return "-";
    }
  }

  applyFilters() {
    this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
  }

  dataSourceFetchSuccessCallback(e) {
    this.vouchesMatchCount = this.gridOptions.dataSource.total();
    this.$scope.$apply();
  }

  dataSourceErrorSuccessCallback(e) {
    if (e.xhr.status == 401) {
      this.authService.refreshToken().then((response) => {
        this.applyFilters();
      }).catch((error) => {
        this.authService.logout();
      });
    } else {
      this.authService.logout();
    }
  }

}

export default VouchesController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/vouches/vouches.controller.js
 **/